import * as React from "react"
import { FormattedMessage } from "react-intl"

export const NoDataWrapper = () => {
	return (
		<div className={ "noDataToShow" }><FormattedMessage defaultMessage={ "Žádná data k zobrazení" } id={ "noData" } /></div>
	)
}
